import { TrendingUp, Target, CalendarCheck, DollarSign, ArrowUpRight } from "lucide-react";

const KPI = [
  {
    testId: "kpi-mqls",
    label: "MQLs This Month",
    value: "487",
    delta: "+12% vs last month",
    deltaTone: "teal",
    Icon: TrendingUp,
    accent: "#00C2A8",
  },
  {
    testId: "kpi-sql",
    label: "Converted to SQL",
    value: "84",
    delta: "17.3% rate — industry avg 2%",
    deltaTone: "teal",
    Icon: Target,
    accent: "#0EA5E9",
  },
  {
    testId: "kpi-demos",
    label: "Demos Booked",
    value: "31",
    delta: "via AI nurture only",
    deltaTone: "muted",
    Icon: CalendarCheck,
    accent: "#00C2A8",
  },
  {
    testId: "kpi-cac",
    label: "Avg Acquisition Cost Recovered",
    value: "$214",
    delta: "per lead · $162–$286 benchmark",
    deltaTone: "muted",
    Icon: DollarSign,
    accent: "#F59E0B",
  },
];

export default function KpiRow() {
  return (
    <section data-testid="kpi-row" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {KPI.map((k, idx) => {
        const { Icon } = k;
        return (
          <article
            key={k.testId}
            data-testid={k.testId}
            className="card-glass card-interactive p-5 enter-up"
            style={{ animationDelay: `${idx * 60}ms` }}
          >
            <div className="flex items-start justify-between mb-4">
              <div
                className="flex items-center justify-center rounded-lg"
                style={{
                  width: 36,
                  height: 36,
                  background: `${k.accent}12`,
                  border: `1px solid ${k.accent}30`,
                }}
              >
                <Icon size={16} color={k.accent} strokeWidth={2} />
              </div>
              <ArrowUpRight size={14} color="var(--text-muted)" />
            </div>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: 12,
                fontWeight: 500,
                color: "var(--text-secondary)",
                letterSpacing: "0.01em",
                marginBottom: 8,
              }}
            >
              {k.label}
            </div>
            <div className="stat-value" data-testid={`${k.testId}-value`}>
              {k.value}
            </div>
            <div
              className="mt-2"
              style={{
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: 11,
                color: k.deltaTone === "teal" ? "#00C2A8" : "var(--text-muted)",
              }}
            >
              {k.delta}
            </div>
          </article>
        );
      })}
    </section>
  );
}
